export const NEONVERSE = {
  brand: 'Neon Verse Studio',
  tagline: 'Your story deserves more than words—it deserves its own soundtrack.',
  seoTitle: 'Neon Verse Studio | Premium Personalized Songs for Every Occasion',
  seoDescription:
    'Transform your memories into professionally crafted personalized songs. Neon Verse Studio creates custom music for birthdays, weddings, baby showers, graduations, businesses, love stories, and every special moment.',
  hero: {
    headline: 'Transform Your Memories, Emotions, and Experiences Into Music',
    subheading:
      'Custom songs inspired by your story, produced in any genre, personalized to your vision, and delivered in high-quality WAV and MP3 formats.',
    primaryCta: 'Create Your Song',
    secondaryCta: 'Share Your Story',
  },
  about: [
    'Neon Verse Studio was founded on a lifelong love for music and the belief that every person has a story worth celebrating.',
    'Music has the power to preserve emotions in a way that words alone cannot. It brings memories back to life, connects generations, and creates moments that last forever.',
    'At Neon Verse Studio, we transform your experiences into original songs that reflect your personality, emotions, and journey. Every project is uniquely crafted from your ideas, ensuring that no two songs are ever the same.',
    "From joyful celebrations to deeply personal milestones, we create music that becomes part of your story.",
  ],
  mission:
    "To transform life's most meaningful moments into timeless music that people can cherish for generations.",
  vision:
    "To become the world's most trusted destination for premium personalized music, where every story finds its perfect soundtrack.",
  location: 'Nashville, TN',
  difference: [
    'Fully personalized songs created from your unique story',
    'Any genre, style, mood, or musical direction',
    'Complete creative freedom and customization',
    'Suitable for individuals, families, businesses, and organizations',
    'Professional-quality audio delivered in WAV and MP3 formats',
    'Premium experience from concept to final production',
    'Every song is created exclusively for you',
  ],
  services: [
    'Birthdays',
    'Weddings',
    'Anniversaries',
    'Baby Showers',
    'Birth Story Songs',
    'Graduation Celebrations',
    'Love Stories',
    'Marriage Proposals',
    'Family Memories',
    "Children's Songs",
    'Retirement Celebrations',
    'Memorial Tributes',
    'Friendship Songs',
    'Business Promotions',
    'Company Anthems',
    'School Songs',
    'Sports Teams',
    'Holiday Celebrations',
    'Travel Memories',
    'Life Journeys',
    'Personal Achievements',
    'Motivational Songs',
    'Podcast Intros',
    'YouTube Theme Songs',
    'Brand Music',
    'Social Media Content',
    'Custom Requests',
  ],
  styles: [
    'Pop',
    'Rock',
    'Acoustic',
    'Country',
    'Classical',
    'Cinematic',
    'Orchestral',
    'Folk',
    'Jazz',
    'Blues',
    'Hip-Hop',
    'Rap',
    'R&B',
    'Soul',
    'EDM',
    'House',
    'Dance',
    'Lo-fi',
    'Ambient',
    'Instrumental',
    "Children's Music",
    'Meditation',
    'Devotional',
    'Bollywood-Inspired',
    'Indian Classical',
    'World Music',
    'Holiday Music',
  ],
  personalization: [
    'Story',
    'Occasion',
    'Language',
    'Genre',
    'Mood',
    'Tempo',
    'Instruments',
    'Vocal Style',
    'Singer Preference',
    'Song Length',
    'Energy Level',
    'Emotional Tone',
    'Special Names',
    'Important Dates',
    'Personal Messages',
    'Inside Jokes',
    'Memories',
    'Quotes',
    'Special Requests',
  ],
  steps: [
    {
      title: 'Tell Us Your Story',
      body: 'Share your memories, ideas, event details, emotions, and vision.',
    },
    {
      title: 'Choose Your Style',
      body: 'Select your preferred genre, mood, vocals, language, and musical direction.',
    },
    {
      title: 'Production Begins',
      body: 'Your song is professionally crafted and refined to match your story.',
    },
    {
      title: 'Receive Your Music',
      body: 'Receive your finished song in premium WAV and MP3 formats, ready to share and enjoy forever.',
    },
  ],
  faqs: [
    {
      q: 'Can you create songs for any occasion?',
      a: 'Yes. We specialize in creating completely original songs inspired by your unique story, regardless of the occasion.',
    },
    {
      q: 'Can I choose the music style?',
      a: 'Absolutely. Every project is tailored to your preferred genre, mood, instrumentation, and vocal style.',
    },
    {
      q: 'What file formats do I receive?',
      a: 'Every completed song is delivered in both high-quality WAV and MP3 formats.',
    },
    {
      q: 'Can businesses order songs?',
      a: 'Yes. We create custom music for businesses, brands, events, schools, podcasts, YouTube creators, and more.',
    },
  ],
  whyLines: [
    'Because memories deserve more than photographs.',
    'Because milestones deserve more than speeches.',
    'Because your story deserves music that is uniquely yours.',
  ],
};
